import { useQueryClient, useMutation } from 'react-query';
import { updateMatchStatus } from "../config/mainRequest";

export const useUpdateMatchStatus = ({ onClose }) => {
  const queryClient = useQueryClient();

  const { isLoading, mutate } = useMutation(updateMatchStatus, {
    onSuccess: () => {
      queryClient.refetchQueries(["allMatchesByAnalystId"]);
      onClose && onClose();
    },
    onError: (error) => {
      console.log(error);
    }
  });

  return {
    isUpdateLoading: isLoading,
    mutateUpdateMatchStatus: mutate
  }
};
